// extracted by mini-css-extract-plugin
export default {"alarms":"Alarms_alarms__U1oQK","activeAlarm":"Alarms_activeAlarm__6Y7sK"};